export default "__VITE_ASSET__CCPAGD_b__"